module.exports = __webpack_public_path__ + "assets/svg/Icons/32/attachment-blue-cd0724.svg";